<!-- MAIN TABLE ---------------------------------------------------->
<p-table
  #dt1
  [value]="productData"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="false"
>
  <ng-template pTemplate="caption">
    <div [formGroup]="form" class="page-control flex align-items-start">
      <div class="grid w-100">
        <div
          class="col-12 flex justify-content-between mb-2 align-items-center"
        >
          <h2 class="text-black-alpha-90">Analiza - Proizvod</h2>
          <div class="flex">
            <button
              class="main-btn"
              [disabled]="!form.valid || productData.length == 0"
              (click)="onExportPdf()"
              [ngClass]="{ disabled: !form.valid || productData.length == 0 }"
            >
              Export PDF <i class="pi pi-file-pdf"></i>
            </button>

            <button
              class="main-btn ml-4"
              (click)="onExportCsv()"
              [disabled]="!form.valid || productData.length == 0"
              [ngClass]="{ disabled: !form.valid || productData.length == 0 }"
            >
              Export CSV <i class="pi pi-file-excel"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="mb-0 flex">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar w-full"
              placeholder="Datum od"
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date_from"
            ></p-calendar>
            <button
              class="clear-btn ml-2"
              (click)="clearFilters('date_from')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="mb-0 flex">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar w-full"
              placeholder="Datum do"
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date_to"
            ></p-calendar>

            <button
              class="clear-btn ml-2"
              (click)="clearFilters('date_to')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="flex mb-0">
            <p-dropdown
              [options]="allProducts"
              formControlName="productId"
              optionValue="id"
              optionLabel="label"
              [filter]="true"
              [showClear]="false"
              placeholder="Izaberi proizvod"
              class="w-100"
              (onChange)="onSearch()"
            >
            </p-dropdown>
            <button
              class="clear-btn ml-2"
              (click)="clearFilters('productId')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header" let-data>
    <tr *ngIf="productData.length != 0 && productData[0]?.data?.length != 0">
      <th style="padding: 0.5rem">Datum</th>

      <th style="padding: 0.5rem">NIP broj</th>
      <th style="width: 5rem; padding: 0.5rem">Količina</th>

      <th
        *ngFor="let header of productData[0]?.exists_operations"
        style="padding: 0.5rem"
      >
        {{ header.label }}
      </th>

      <th style="padding: 0.5rem">Ukupno (min/kom)</th>

      <th style="width: 3.5rem; padding: 0.5rem">Info</th>
    </tr>

    <tr *ngIf="productData.length != 0 && productData[0]?.data?.length == 0">
      <td colspan="10" class="no-data">Nema pronađenih prodataka.</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-data>
    <tr *ngFor="let item of data.data">
      <td>
        <span>{{ item.date }} </span>
      </td>
      <td>
        <span>{{ item.batch }} </span>
      </td>
      <td>
        <span>{{ item.required_units }} </span>
      </td>

      <td *ngFor="let header of productData[0]?.exists_operations">
        <span>{{ item[header?.label] }}</span>
      </td>

      <td>
        <span>{{ item.total_time_per_pieces }} </span>
      </td>

      <td>
        <span
          ><button class="second-btn small-btn" (click)="onShowMoreInfo(item)">
            <i class="pi pi-info"></i>
          </button>
        </span>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="10">Nema pronađenih prodataka.</td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  header="Dodatne informacije"
  [(visible)]="showMoreInfo"
  [modal]="true"
  [style]="{ width: '70vw', height: 'auto' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  (click)="onCloseModal(showMoreInfo)"
>
  <p-table
    [value]="dataInfo"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    *ngIf="dataInfo"
  >
    <ng-template pTemplate="header" let-data>
      <tr>
        <th>Partner</th>
        <th>Škart (kom)</th>
        <th>Škart (%)</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
      <tr>
        <td>
          <span>{{ dataInfo[0]?.partner }}</span>
        </td>
        <td>
          <span>{{ dataInfo[0]?.scrap_percent }} </span>
        </td>

        <td>
          <span>{{ dataInfo[0]?.total_scrap }} </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- MAX TIME-------------------------------------------------- -->
<div
  class="mt-4"
  *ngIf="productData.length != 0 && productData[0]?.data?.length != 0"
>
  <p-table
    #dt1
    [value]="productData"
    dataKey="id"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    class="mt-4"
    *ngIf="productData"
  >
    <ng-template pTemplate="header" let-data>
      <tr>
        <th colspan="3" style="padding: 0.5rem">
          <span></span>
        </th>

        <th
          *ngFor="let header of productData[0]?.exists_operations"
          style="padding: 0.5rem"
        >
          {{ header.label }}
        </th>
        <th style="padding: 0.5rem">Ukupno (min/kom)</th>

        <th style="width: 3.5rem; padding: 0.5rem">Info</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
      <tr *ngFor="let item of data.summaryArray">
        <td colspan="3">
          <span> {{ data.maxTimeHeader }}</span>
        </td>
        <td *ngFor="let header of productData[0]?.exists_operations">
          <span>{{ item[header?.label].max }}</span>
        </td>

        <td>
          <span>{{ productData[0].time_per_pieces.max }} </span>
        </td>

        <td>
          <span
            ><button
              class="second-btn small-btn"
              (click)="onShowMinMaxInfo(productData[0], 'max')"
            >
              <i class="pi pi-info"></i>
            </button>
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  header="Dodatne informacije"
  [(visible)]="showMaxInfo"
  [modal]="true"
  [style]="{ width: '70vw', height: 'auto' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  (click)="onCloseModal(showMoreInfo)"
>
  <p-table
    [value]="productionInfo"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    *ngIf="productionInfo"
  >
    <ng-template pTemplate="header" let-data>
      <tr>
        <th>Škart (kom)</th>
        <th>Škart (%)</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
      <tr>
        <td>
          <span>{{ productionInfo[0]?.scrap_percent.max }} </span>
        </td>

        <td>
          <span>{{ productionInfo[0]?.scrap.max }} </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- MIN TIME-------------------------------------------------- -->
<div
  class="mt-4"
  *ngIf="productData.length != 0 && productData[0]?.data?.length != 0"
>
  <p-table
    #dt1
    [value]="productData"
    dataKey="id"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    class="mt-4"
    *ngIf="productData"
  >
    <ng-template pTemplate="header" let-data>
      <tr>
        <th colspan="3" style="padding: 0.5rem">
          <span></span>
        </th>

        <th
          *ngFor="let header of productData[0]?.exists_operations"
          style="padding: 0.5rem"
        >
          {{ header.label }}
        </th>
        <th style="padding: 0.5rem">Ukupno (min/kom)</th>

        <th style="width: 3.5rem; padding: 0.5rem">Info</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
      <tr *ngFor="let item of data.summaryArray">
        <td colspan="3">
          <span> {{ data.minTimeHeader }}</span>
        </td>
        <td *ngFor="let header of productData[0]?.exists_operations">
          <span>{{ item[header?.label].min }}</span>
        </td>

        <td>
          <span>{{ productData[0].time_per_pieces.min }} </span>
        </td>

        <td>
          <span
            ><button
              class="second-btn small-btn"
              (click)="onShowMinMaxInfo(productData[0], 'min')"
            >
              <i class="pi pi-info"></i>
            </button>
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  header="Dodatne informacije"
  [(visible)]="showMinInfo"
  [modal]="true"
  [style]="{ width: '70vw', height: 'auto' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  (click)="onCloseModal(showMoreInfo)"
>
  <p-table
    [value]="productionInfo"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    *ngIf="productionInfo"
  >
    <ng-template pTemplate="header" let-data>
      <tr>
        <th>Škart (kom)</th>
        <th>Škart (%)</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
      <tr>
        <td>
          <span>{{ productionInfo[0]?.scrap_percent.min }} </span>
        </td>

        <td>
          <span>{{ productionInfo[0]?.scrap.min }} </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- AVERAGE TIME-------------------------------------------------- -->
<div
  class="mt-4"
  *ngIf="productData.length != 0 && productData[0]?.data?.length != 0"
>
  <p-table
    #dt1
    [value]="productData"
    dataKey="id"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    class="mt-4"
    *ngIf="productData"
  >
    <ng-template pTemplate="header" let-data>
      <tr>
        <th colspan="3" style="padding: 0.5rem">
          <span></span>
        </th>

        <th
          *ngFor="let header of productData[0]?.exists_operations"
          style="padding: 0.5rem"
        >
          {{ header.label }}
        </th>
        <th style="padding: 0.5rem">Ukupno (min/kom)</th>

        <th style="width: 3.5rem; padding: 0.5rem">Info</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
      <tr *ngFor="let item of data.summaryArray">
        <td colspan="3">
          <span> {{ data.averageTimeHeader }}</span>
        </td>
        <td *ngFor="let header of productData[0]?.exists_operations">
          <span>{{ item[header?.label].avg }}</span>
        </td>

        <td>
          <span>{{ productData[0].time_per_pieces.avg }} </span>
        </td>

        <td>
          <span
            ><button
              class="second-btn small-btn"
              (click)="onShowMinMaxInfo(productData[0], 'avg')"
            >
              <i class="pi pi-info"></i>
            </button>
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  header="Dodatne informacije"
  [(visible)]="showAvgInfo"
  [modal]="true"
  [style]="{ width: '70vw', height: 'auto' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  (click)="onCloseModal(showAvgInfo)"
>
  <p-table
    [value]="productionInfo"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    *ngIf="productionInfo"
  >
    <ng-template pTemplate="header" let-data>
      <tr>
        <th>Škart (kom)</th>
        <th>Škart (%)</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
      <tr>
        <td>
          <span>{{ productionInfo[0]?.scrap_percent.avg }} </span>
        </td>

        <td>
          <span>{{ productionInfo[0]?.scrap.avg }} </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- MEDIOCRITY -------------------------------------------------- -->
<div
  class="mt-4"
  *ngIf="productData.length != 0 && productData[0]?.data?.length != 0"
>
  <p-table
    #dt1
    [value]="productData"
    dataKey="id"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    class="mt-4"
    *ngIf="productData"
  >
    <ng-template pTemplate="header" let-data>
      <tr>
        <th colspan="3" style="padding: 0.5rem">
          <span></span>
        </th>

        <th
          *ngFor="let header of productData[0]?.exists_operations"
          style="padding: 0.5rem"
        >
          {{ header.label }}
        </th>
        <th style="padding: 0.5rem">Ukupno (min/kom)</th>

        <th style="padding: 0.5rem">Škart (kom)</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
      <tr *ngFor="let item of data.summaryArray">
        <td colspan="3">
          <span> {{ data.mediocrityHeader }}</span>
        </td>
        <td *ngFor="let header of productData[0]?.exists_operations">
          <span>{{ item[header?.label].stdev }}</span>
        </td>

        <td>
          <span>{{ productData[0].time_per_pieces.stdev }} </span>
        </td>

        <td>
          <span> {{ productData[0].scrap.stdev }} </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
